import React, { useEffect, useRef } from 'react';

function CustomScrollTrigger({ onEnter, onExit, children, className = '', ...props }) {
  const containerRef = useRef(null);
  const hasEntered = useRef(false);

  useEffect(() => {
    const currentContainer = containerRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          hasEntered.current = true;
          if (typeof onEnter === 'function') {
            onEnter();
          }
          if (!onExit) {
            observer.disconnect();
          }
        } else {
          if (hasEntered.current && typeof onExit === 'function') {
            onExit();
          }
        }
      },
      { threshold: 0.1 }
    );

    if (currentContainer) {
      observer.observe(currentContainer);
    }

    return () => {
      if (currentContainer) {
        observer.unobserve(currentContainer);
      }
      observer.disconnect();
    };
  }, [onEnter, onExit]);

  return (
    <div className={`custom-scroll-trigger ${className}`.trim()} ref={containerRef} {...props}>
      {children}
    </div>
  );
}

export default CustomScrollTrigger;
